(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  const setup = (root) => {
    root.querySelectorAll('[data-dmi-carousel]').forEach((carousel) => {
      if (carousel.dataset.dmiReady) return;
      carousel.dataset.dmiReady = 'true';
      const pause = carousel.querySelector('[data-dmi-pause]');
      const mobile = matchMedia('(max-width: 1023px)');
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = mobile.matches || reduceMotion.matches;
      const updatePause = () => {
        carousel.classList.toggle('paused', paused);
        if (pause) {
          pause.textContent = paused ? pause.dataset.play : pause.dataset.pause;
          pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        }
      };
      const stop = () => { paused = true; updatePause(); };
      pause?.addEventListener('click', () => { paused = !paused; updatePause(); });
      carousel.addEventListener('focusin', (event) => { if (event.target !== pause) stop(); });
      carousel.addEventListener('click', (event) => {
        if (event.target.closest('.prev, .next, .jump-to-slide')) stop();
      });
      carousel.addEventListener('keydown', (event) => {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[role="button"]')) {
          event.preventDefault();
          event.target.click();
        }
      });
      const syncSlides = () => {
        const slides = Array.from(carousel.querySelectorAll('.slide'));
        slides.forEach((slide) => {
          const inactive = !slide.classList.contains('active');
          slide.inert = inactive;
          slide.setAttribute('aria-hidden', String(inactive));
        });
        carousel.querySelectorAll('.jump-to-slide li').forEach((dot, index) => {
          dot.setAttribute('role', 'button');
          dot.tabIndex = 0;
          dot.setAttribute('aria-label', carousel.dataset.slideLabel.replace('[number]', index + 1));
          dot.setAttribute('aria-current', String(dot.classList.contains('active')));
        });
      };
      const observer = new MutationObserver(syncSlides);
      observer.observe(carousel.querySelector('.jump-to-slide'), { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      carousel.querySelectorAll('.slide').forEach((slide) => observer.observe(slide, { attributes: true, attributeFilter: ['class'] }));
      const respectPreference = () => { if (mobile.matches || reduceMotion.matches) stop(); };
      mobile.addEventListener('change', respectPreference);
      reduceMotion.addEventListener('change', respectPreference);
      updatePause();
      syncSlides();
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(carousel)) return;
        observer.disconnect();
        mobile.removeEventListener('change', respectPreference);
        reduceMotion.removeEventListener('change', respectPreference);
      }, { once: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
  else setup(document);
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = `${window.Shopify.routes.root}cart`;
    } else {
      setTimeout(() => {
        const cartButton = document.querySelector('[data-cart-mini-toggle]');
        if (cartButton) {
          cartButton.click();
        }
      }, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
